define.alias("shared/utils/remove-html-literals", "calendar/utils/remove-html-literals");